import React from 'react';
import { Outlet } from 'react-router';

export const DonationsLayout = () => {
	return (
		<>
			<Outlet />
		</>
	);
};

export default DonationsLayout;
